import { render } from "./SectionStats.vue?vue&type=template&id=13ecc7e4&scoped=true"
import script from "./SectionStats.vue?vue&type=script&lang=js"
export * from "./SectionStats.vue?vue&type=script&lang=js"

import "./SectionStats.vue?vue&type=style&index=0&id=13ecc7e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ecc7e4"]])

export default __exports__